import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PatientDesignPage } from './patient-design.page';

const routes: Routes = [
  {
    path: '',
    component: PatientDesignPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PatientDesignPageRoutingModule {}
